<img class="logo-stt" src="../../../assets/img/logo-stt.svg" alt="Logo App">
<p>{{ 'stt.bid.title' | translate }}</p>
